<template>
  <div class="container">
    <filter-wrapper
      class="header"
      :filter-item="{ dateRange: true }"
    ></filter-wrapper>
    <el-row :gutter="10" style="height: 40px">
      <el-col :span="2">
        <el-button type="text" size="mini" @click="selectAll">全选</el-button>
        <el-button
          type="text"
          class="danger-text"
          size="mini"
          @click="cancelAllSelect"
        >取消</el-button
        >
      </el-col>
      <el-col :span="3">
        <el-input
          v-model="search"
          size="mini"
          placeholder="可通过餐厅, 食堂, 操作人名称快速搜索"
          clearable
        >search</el-input
        >
      </el-col>
      <el-col :span="18">
        <el-badge class="mark" :value="(count[1] && count[1].length) || 0">
          <el-tag type="primary" size="mini">采集总数</el-tag> </el-badge
        >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <el-badge class="mark" :value="(count[2] && count[2].length) || 0">
          <el-tag type="success" size="mini">回测总数</el-tag> </el-badge
        >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <el-badge class="mark" :value="(count[3] && count[3].length) || 0">
          <el-tag type="warning" size="mini">待标注</el-tag> </el-badge
        >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <el-badge class="mark" :value="filterList.length || 0">
          <el-tag type="success" size="mini">总计</el-tag> </el-badge
        >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <el-button size="mini" type="text" @click="getTaskHistory"
        >刷新</el-button
        >&nbsp;&nbsp;
        <el-button size="mini" type="text" @click="randomSendLabelTask"
        >发送随机批次</el-button
        >&nbsp;&nbsp;
        <el-badge class="mark" :value="selectedLabel.length">
          <el-button :disabled="selectedLabel.length === 0" size="mini" type="text" @click="sendSelectedLable">
            发送勾选批次
          </el-button>
        </el-badge>
      </el-col>
    </el-row>
    <vvTable
      :config="tableConfig"
      :data="filterList"
      :height="tableHight"
      :itemHeight="55"
    >
      <template slot-scope="scope" slot="canteen_slot">
        {{ scope.row.eatery_name + " -> " + scope.row.canteen_name }}
      </template>
      <template slot-scope="scope" slot="regionSlot">
        <el-tag
          type="danger"
          v-if="scope.row.region_img_get_state === '0'"
          size="mini"
        >未获取</el-tag
        >
        <el-tag type="success" v-else size="mini">已获取</el-tag>
      </template>

      <template slot-scope="scope" slot="eventSlot">
        <!--<button>sadas</button>-->
        <el-button type="text" @click="reCheck(scope.row)" size="mini"
        >回看</el-button
        >
        <el-button type="text" @click="goCheck(scope.row)" size="mini"
        >编辑</el-button
        >
        &nbsp;&nbsp;
        <span v-if="userGroup > 499">
          <el-button type="text" @click="viewAccuracy(scope.row)" size="mini"
          >准确率</el-button
          >
          <!--<el-button :disabled="scope.row.region_img_get_state === '1'" type="text"-->
          <!--@click="getImagesToRegionFix(scope.row)" size="mini">矫正识别框</el-button>-->
        </span>
      </template>
      <template slot-scope="scope" slot="select_slot">
        <el-button
          type="text"
          size="mini"
          v-if="selectedLabel.indexOf(scope.row.label_task_uuid) === -1"
          :disabled="scope.row.region_img_get_state === '1'"
          @click="handleSelect(scope.row)"
        >选择
        </el-button>
        <el-button
          type="text"
          class="danger-text"
          size="mini"
          @click="cancelSelect(scope.row)"
          v-else
        >取消</el-button
        >
      </template>
      <template slot-scope="scope" slot="source_slot">
        <el-tag type="primary" size="mini" v-if="scope.row.label_source === '1'"
        >采集</el-tag
        >
        <el-tag type="warning" size="mini" v-if="scope.row.label_source === '2'"
        >回测</el-tag
        >
        <el-tag type="success" size="mini" v-if="scope.row.label_source === '3'"
        >待标注</el-tag
        >
        <i calss="el-icon el-icon-ali-fire"></i>
      </template>
      <template slot-scope="scope" slot="end_ts_slot">{{
        tsToDate(scope.row.end_check_ts)
      }}</template>
      <template slot-scope="scope" slot="start_ts_slot">{{
        tsToDate(scope.row.start_check_ts)
      }}</template>
      <template slot-scope="scope" slot="day_ts_slot">{{
        tsToDate(scope.row.day_ts)
      }}</template>
      <template slot-scope="scope" slot="reviewSlot">
        <el-tag type="success" size="mini" v-if="scope.row.who_review">{{
          scope.row.who_review
        }}</el-tag>
        <el-tag type="danger" size="mini" v-else>未复核</el-tag>
      </template>
    </vvTable>
  </div>
</template>
<script>
import filterWrapper from '_c/filterWrapper';
import {mapGetters, mapMutations} from 'vuex';
import moment from 'moment';
import {
  apiGetAllUserList,
  apiGetCheckedImgByTaskId,
  apiGetTaskHistory,
  apiSendLabelTaskList,
  apiUploadimageFromBatch
} from '@/api';
import pinyinMatch from 'pinyin-match';
import util from '@/lib/util';

import vvTable from 'vue-virtual-table';

export default {
  name: "taskHistory",
  components: {
    filterWrapper,
    vvTable
  },
  data() {
    return {
      selectedLabel: [],
      tableConfig: [
        { prop: "_action", name: "选择", actionName: "select_slot", width: 50 },
        { prop: "_action", name: "类型", actionName: "source_slot", width: 50 },
        {
          prop: "_action",
          name: "餐厅",
          actionName: "canteen_slot",
          width: 200
        },
        { prop: "username", name: "操作人", width: 120 },
        { prop: "_action", name: "任务时间", actionName: "day_ts_slot" },
        { prop: "_action", name: "开始时间", actionName: "start_ts_slot" },
        { prop: "_action", name: "结束时间", actionName: "end_ts_slot" },
        {
          prop: "_action",
          name: "复核人",
          actionName: "reviewSlot",
          width: 80
        },
        {
          prop: "_action",
          name: "识别框",
          actionName: "regionSlot",
          width: 80
        },
        { prop: "_action", name: "操作", actionName: "eventSlot", width: 200 }
      ],
      search: "",
      markerList: [],
      marker: {},
      showType: [],
      taskHistory: [],
      typeList: [{ label: "采集", value: "1" }, { label: "回测", value: "2" }]
    };
  },
  created() {
    this.setSubTitle("已完成任务");
    // this.getMarkerList();
    // this.refresh();
    this.search = this.$route.params.canteen || "";
  },
  mounted() {
    this.getTaskHistory();
  },
  methods: {
    ...mapMutations([
      "setSubTitle",
      "setCurrentCheckTaskInfo",
      "emitLoading",
      "removeLoading"
    ]),
    selectAll() {
      const label_task_ids = this.filterList.map(a => a.label_task_uuid);
      this.selectedLabel = this.$_.uniq(
        this.selectedLabel.concat(label_task_ids)
      );
    },
    cancelAllSelect() {
      this.selectedLabel = [];
    },
    async sendLabelTaskList (label_task_info_list) {
      this.emitLoading();
      try {
        await apiSendLabelTaskList(label_task_info_list);
        this.removeLoading();
        this.$message.warning(`${label_task_info_list.length}条批次发送成功`);
        this.selectedLabel = [];
        this.getTaskHistory();
      } catch (e) {
        this.$message.error(`${label_task_info_list.length}条批次发送失败, ${e.message}`);
        this.removeLoading();
      }
    },
    sendSelectedLable() {
      let list = this.selectedLabel.map(a => {
        return this.$_.find(this.taskHistory, b => {
          return a === b.label_task_uuid;
        });
      });
      this.sendLabelTaskList(list);
    },
    handleSelect(row) {
      const { label_task_uuid } = row;
      if (this.selectedLabel.indexOf(label_task_uuid) === -1) {
        this.selectedLabel.push(label_task_uuid);
      }
    },
    cancelSelect(row) {
      const { label_task_uuid } = row;
      const idx = this.selectedLabel.indexOf(label_task_uuid);
      if (idx !== -1) {
        this.selectedLabel.splice(idx, 1);
      }
    },
    randomSendLabelTask() {
      // const taskList = this.filterList;
      let unSendTask = this.taskHistoryByUsername.filter(
        a => a.region_img_get_state === "0"
      );
      let list = [];
      if (unSendTask.length < 50) {
        list = unSendTask;
      } else {
        let count = unSendTask.length;
        for (let i = 0; i < 50; i++) {
          let index = ~~(Math.random() * count) + i;
          list[i] = unSendTask[index];
          unSendTask[index] = unSendTask[i];
          count--;
        }
      }
      this.sendLabelTaskList(list);
      // console.log(list);
    },
    filterHandler(value, row, column) {
      const property = column["property"];
      console.log(row[property], value);
      return row[property] === value;
    },
    async getImagesToRegionFix(row) {
      try {
        await apiUploadimageFromBatch({
          label_task_uuid: row.label_task_uuid,
          source: row.label_source,
          label_task_day_ts: row.day_ts,
          canteen_id: row.canteen_id
        });
        // let res = this.$_.find(this.taskHistory, a => a.label_task_uuid === row.label_task_uuid)
        // this.$set(res, '')
        this.getTaskHistory();
        this.$message.warning("获取成功");
      } catch (e) {
        this.$message.error(e.message);
      }
    },
    viewAccuracy(row) {
      // this.$message.error('开发中...');
      this.$router.push({
        name: "backDataAccByCanteen",
        params: {
          canteen: {
            canteen_name: row.canteen_name,
            canteen_id: row.canteen_id
          },
          eatery: {
            eatery_name: row.eatery_name,
            eatery_id: row.eatery_id
          },
          dateRange: {
            start_ts: row.day_ts,
            end_ts: row.day_ts * 1000 + 3600 * 24
          }
        }
      });
    },
    async getTaskHistory() {
      try {
        let dateRange = this.listQuery.dateRange;
        let res = await apiGetTaskHistory({
          start_ts: util.dateToUnixtimestamp(dateRange[0], 0),
          end_ts: util.dateToUnixtimestamp(dateRange[1], 1)
        });
        this.taskHistory = res.canteen_info_list;
      } catch (e) {
        this.$message.error("获取历史失败");
        console.log(e);
      }
    },
    assignment() {
      this.$message.error("此功能正在开发中......");
    },
    // 回看
    async reCheck(row) {
      // this.$message.warning('正在跳转..');
      // if (row.label_source === '1') {
      //   return this.$message.error('采集数据回看功能还在开发');
      // }
      this.$router.push({
        name: "taskHistoryRecheck",
        params: {
          taskInfo: row,
          checkMode: false
        }
      });
    },
    async getTaskInfo(row) {
      await apiGetCheckedImgByTaskId(row.label_task_uuid);
    },
    goCheck(row) {
      // return this.$message.error("还未完成");
      // eslint-disable-next-line
      this.$router.push({
        name: "taskHistoryRecheck",
        params: {
          taskInfo: row,
          checkMode: true
        }
      });
    },
    tsToDate(ts) {
      return moment(ts * 1000).format("YYYY-MM-DD HH:mm");
    },
    async getMarkerList() {
      let res = await apiGetAllUserList(this.apiKey);
      this.markerList = res.user_list.filter(
        a => a.user_group === 1 || a.user_group === "1"
      );
    }
  },
  computed: {
    ...mapGetters(["userinfo", "listQuery"]),
    tableHight () {
      const clientHeight = window.innerHeight;
      return clientHeight - 80;
    },
    isSuperUser() {
      return this.userGroup === 1000;
    },
    apiKey() {
      return this.userinfo().api_key;
    },
    userGroup() {
      return this.userinfo().userGroup;
    },
    handlerOptions() {
      return {
        key: ""
      };
    },
    taskHistoryByUsername() {
      return this.isSuperUser
        ? this.taskHistory
        : this.taskHistory.filter(a => a.username === this.userinfo().username);
    },
    filterList() {
      let search = this.search;
      let list = this.taskHistoryByUsername;
      list.sort((a, b) => {
        return -a.end_check_ts + b.end_check_ts;
      });
      return list.filter(a => {
        let res = pinyinMatch.match(
          a.canteen_name + "," + a.eatery_name + "," + a.username,
          search
        );
        return res.length > 0;
      });
    },
    count() {
      return this.$_.groupBy(this.filterList, "label_source");
    }
  },
  watch: {
    listQuery: {
      handler() {
        this.getTaskHistory();
      },
      deep: true
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  .header {
    top: -45px;
    width: 500px;
  }
}
</style>
